export default {"src":"/uk/_next/static/media/spot-search.cd45cb1d.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};